<script>
/**
 * @description: 表格列组件 动态渲染多级表头
 * @param {Object} column 列配置
 * @TODO: 目前只能单列渲染，多列渲染存在问题（子节点排序异常）
 */

export default {
	name: "ChildNodes",
	props: {
		column: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},
	render(createElement) {
		const deepRender = (column) => {
			const node = [];

			if (column.required) {
				node.push(
					createElement("template", { slot: "header" }, [
						createElement("span", { style: { color: "red" } }, "*"),
						column.label
					])
				);
			} else if (column.headerSlot) {
				if (this.$scopedSlots[column.headerSlot]) {
					node.push(createElement("template", { slot: "header" }, [this.$scopedSlots[column.headerSlot]()]));
				}
			}

			const children =
				column.children && column.children.length > 0 ? column.children.map((item) => deepRender(item)) : [];

			return createElement(
				"el-table-column",
				{
					props: { ...column },
					scopedSlots: {
						default: ({ row, $index }) => {
							if (column.slot && this.$scopedSlots[column.slot]) {
								return this.$scopedSlots[column.slot]({ row, $index });
							}

							return this.$emptyTextConversion(row[column.prop]);
						}
					}
				},
				node.concat(children)
			);
		};

		return deepRender(this.column);
	}
};
</script>
